// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Place from "./pages/Place/Place.bs.jsx";
import * as React from "react";
import * as Homepage from "./pages/Homepage/Homepage.bs.jsx";
import * as MyPlaces from "./pages/MyPlaces/MyPlaces.bs.jsx";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as ToastBanner from "./components/Toast/ToastBanner.bs.jsx";
import * as FcmTokenSync from "./components/FcmTokenSync/FcmTokenSync.bs.jsx";
import * as PageNotFound from "./pages/PageNotFound/PageNotFound.bs.jsx";
import * as PlaceSetting from "./pages/PlaceSetting/PlaceSetting.bs.jsx";
import * as SignInWrapper from "./components/SignInWrapper/SignInWrapper.bs.jsx";
import * as LoadingFullscreen from "./components/LoadingFullscreen/LoadingFullscreen.bs.jsx";
import * as ShareLinkResolver from "./pages/ShareLinkResolver/ShareLinkResolver.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as PlacePersonsSetting from "./pages/PlacePersonsSetting/PlacePersonsSetting.bs.jsx";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";
import * as FirebaseAuthProvider from "./components/FirebaseAuthProvider/FirebaseAuthProvider.bs.jsx";

import './styles/index.css'
;

import '@oddbird/popover-polyfill'
;

function App(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let match = url.path;
  let tmp;
  let exit = 0;
  if (match !== 0) {
    switch (match.hd) {
      case "misto" :
        exit = 1;
        break;
      case "s" :
        let match$1 = match.tl;
        tmp = match$1 !== 0 && match$1.tl === 0 ? <FirebaseAuthProvider.make>
            <SignInWrapper.make>
              <ShareLinkResolver.make
                linkId={match$1.hd}
              />
            </SignInWrapper.make>
          </FirebaseAuthProvider.make> : <PageNotFound.make />;
        break;
      default:
        tmp = <PageNotFound.make />;
    }
  } else {
    tmp = <Homepage.make />;
  }
  if (exit === 1) {
    let maybePlaceSubPath = Stdlib_List.tail(url.path);
    let tmp$1;
    if (maybePlaceSubPath !== undefined && maybePlaceSubPath !== 0) {
      let placeId = Stdlib_List.headOrThrow(maybePlaceSubPath);
      let placeIdSub = Stdlib_List.tail(maybePlaceSubPath);
      let tmp$2;
      if (placeIdSub !== undefined) {
        if (placeIdSub !== 0) {
          if (placeIdSub.hd === "nastaveni") {
            let match$2 = placeIdSub.tl;
            tmp$2 = match$2 !== 0 ? (
                match$2.hd === "osob" && match$2.tl === 0 ? <PlacePersonsSetting.make
                    placeId={placeId}
                  /> : <PageNotFound.make />
              ) : <PlaceSetting.make
                placeId={placeId}
              />;
          } else {
            tmp$2 = <PageNotFound.make />;
          }
        } else {
          tmp$2 = <Place.make
            placeId={placeId}
          />;
        }
      } else {
        tmp$2 = <PageNotFound.make />;
      }
      tmp$1 = <>
        <React.Suspense
          fallback={null}
        >
          {<FcmTokenSync.make
            placeId={placeId}
          />}
        </React.Suspense>
        {tmp$2}
      </>;
    } else {
      tmp$1 = <MyPlaces.make />;
    }
    tmp = <FirebaseAuthProvider.make>
      <SignInWrapper.make>
        {tmp$1}
      </SignInWrapper.make>
    </FirebaseAuthProvider.make>;
  }
  return <React.Suspense
    fallback={<LoadingFullscreen.make />}
  >
    {tmp}
    <ToastBanner.make />
  </React.Suspense>;
}

let make = App;

export {
  make,
}
/*  Not a pure module */
